module.exports = __webpack_public_path__ + "img/PensiveTurtle.2c684485.svg";